import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
import { fontStringify } from "pdfmake/src/helpers.js";
export default class CxcDetalle {
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);

    let imgColumn = {
      // star-sized columns fill the remaining space
      // if there's more than one star-column, available width is divided equally

      text: "",
      width: "10%",
    };
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: ["DEL " + mainData.FI + "\n", "A " + mainData.FF + "\n"],
            },
            // {
            //   // fixed width
            //   width: "35%",
            //   alignment: "left",
            //   bold: true,
            //   text: ["Monto:  " + mainData.monto + mainData.currency + "\n"],
            // },
            {
              // % width
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*", "*"],
                heights: 25,
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let headers = [
      {
        text: "Fecha",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
      {
        text: "Cantidad comensales",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
    ];

    let times = [headers];

    for (let time in data) {
      let rowToAdd = [];

      rowToAdd = [
        {
          text: [time + "\n"],
          fontSize: 12,
          alignment: "left",
          fillColor: "#ededed",
          bold: true,
        },
        {
          text: data[time].ComensalesDia,
          fontSize: 12,
          alignment: "center",
          fillColor: "#ededed",
        },
      ];
      times.push(rowToAdd);
      for (let Horas in data[time].Horas) {
        let rowToAdd = [];
        rowToAdd = [
          {
            text: [data[time].Horas[Horas].hora + "\n"],
            fontSize: 12,
            alignment: "left",
          },
          {
            text: data[time].Horas[Horas].comensales,
            fontSize: 12,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    }

    return times;
  }
}
